export default __webpack_public_path__ + "static/media/customerLeaving.0315b7d9.mp3";